import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AdminOrganization, AdminUser, PatchOperation } from '@app/_store';
import { GetAdminOrganizationsResponse, GetAdminOverviewResponse, GetAdminUsersResponse } from './admin-api';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  constructor(
    private http: HttpClient,
    private store: Store
  ) {}

  getUsers(): Observable<GetAdminUsersResponse> {
    return this.http.get<GetAdminUsersResponse>(`${environment.apiUrl}/admin/users`);
  }

  getUser(id: string): Observable<AdminUser> {
    return this.http.get<AdminUser>(`${environment.apiUrl}/admin/users/${id}`);
  }

  getOrganizations(): Observable<GetAdminOrganizationsResponse> {
    return this.http.get<GetAdminOrganizationsResponse>(`${environment.apiUrl}/admin/organizations`);
  }

  getOrganization(id: string): Observable<AdminOrganization> {
    return this.http.get<AdminOrganization>(`${environment.apiUrl}/admin/organizations/${id}`);
  }

  patchOrganization(id: string, operations: PatchOperation[]): Observable<AdminOrganization> {
    return this.http.patch<AdminOrganization>(`${environment.apiUrl}/admin/organizations/${id}`, operations);
  }

  removeUserFromOrganization(userId: string, organizationId: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/admin/users/${userId}/organizations/${organizationId}`);
  }

  deleteUser(userId: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/admin/users/${userId}`);
  }

  getOverview(): Observable<GetAdminOverviewResponse> {
    return this.http.get<GetAdminOverviewResponse>(`${environment.apiUrl}/admin/overview`);
  }
}
